import User from "./user";
import Role from "./role";
import RolesTask from "./RolesTask";
 
 class Task {
  date: string;                                    
  date_id_transport: string | null;                
  debord: number;                                  
  hourly_end: string;                              
  hourly_start: string;                            
  id_case_plannings: string;                       
  id_location: string;                             
  id_plannings: string;                            
  id_transport: string | null;                     
  id_type_action: string;                          
  nbBigPackage: number;                            
  nbSmallPackage: number;                          
  status: string;                                  
  roles: Role[];                                   
  users: User[];
  rolesTasks: RolesTask[];

  constructor(
    date: string,
    date_id_transport: string | null,
    debord: number,
    hourly_end: string,
    hourly_start: string,
    id_case_plannings: string,
    id_location: string,
    id_plannings: string,
    id_transport: string | null,
    id_type_action: string,
    nbBigPackage: number,
    nbSmallPackage: number,
    status: string,
    roles: Role[],
    users: User[],
    rolesTasks: RolesTask[]
  ) {
    this.date = date;
    this.date_id_transport = date_id_transport;
    this.debord = debord;
    this.hourly_end = hourly_end;
    this.hourly_start = hourly_start;
    this.id_case_plannings = id_case_plannings;
    this.id_location = id_location;
    this.id_plannings = id_plannings;
    this.id_transport = id_transport;
    this.id_type_action = id_type_action;
    this.nbBigPackage = nbBigPackage;
    this.nbSmallPackage = nbSmallPackage;
    this.status = status;
    this.roles = roles;
    this.users = users;
    this.rolesTasks = rolesTasks
  }
}

export default Task;